import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

(function ($) {
    $(document).ready(function () {
        const anchors = $(".anchor-navigation .anchors");
        const target = $(".magnet");
        const countOfSection = $(".main-page-wrap section").length;

        // magnet circle animation
        const initMagnetAnimation = () => {

            function magnetHover(e) {
                let element = $(this);
                let circle = element.find(".magnet-circle");
                const width = element.outerWidth();
                const height = element.outerHeight();

                let x = (e.pageX - element.offset().left - width / 2) * (width > height ? height / width : 1);
                let y = (e.pageY - element.offset().top - height / 2) * (height > width ? width / height : 1);

                gsap.to(circle, 0.2, {
                    x: x,
                    y: y
                })

            }

            if (target.length > 0) {
                target.append("<div class='magnet-circle'></div>");
                target.on("mousemove", magnetHover);
            }
        }

        initMagnetAnimation();

        //anchor navigation
        const anchorNavigation = () => {
            for(let i = 1; i <= countOfSection; i++) {
                anchors.append(`<div class='nav-anchor' data-id=${i}></div>`);
            }
        }

        anchors.on("click", ".nav-anchor", (e) => {
            let target = $(e.currentTarget);

            $(".nav-anchor").removeClass("active");
            target.addClass("active");

            $("html, body").animate({
                scrollTop: $(".main-page-wrap section").eq(target.index()).offset().top - 60
            }, 500);
        })

        anchorNavigation();

        //add class when section enter to viewport
        const sections = gsap.utils.toArray(".main-page-wrap section");

        sections.forEach((section, index) => {
            gsap.from(section, {
                scrollTrigger: {
                    start: "top center",
                    end: "bottom center",
                    trigger: section,
                    toggleClass: {
                        targets: $(".nav-anchor").eq(index), className: "active"
                    },
                    onEnter: () => {
                        $(section).addClass("-on-screen")
                    }
                }
            });
        });
    })
})(jQuery);